import axios from 'axios';
import type { ChatMessage } from './ChatApi';

export async function rateChatMessage(
  messageId: number,
  rating: number
): Promise<{ message: ChatMessage }> {
  return axios
    .put(route('api.chat-messages.rate', { chatMessage: messageId }), { rating })
    .then((res) => res.data);
}

export function streamChatMessage(chat_id: number, content: string, feature?: string) {
  return axios.post(
    route('api.chats.stream', { chat: chat_id }),
    { content, feature },
    {
      adapter: 'fetch',
      responseType: 'stream',
      withCredentials: true
    }
  );
}
